import { render, staticRenderFns } from "./LogConversationPane.vue?vue&type=template&id=53b7ed20&scoped=true"
import script from "./LogConversationPane.vue?vue&type=script&lang=js"
export * from "./LogConversationPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7ed20",
  null
  
)

export default component.exports